import { forwardRef, useEffect, useState } from 'react';
import classes from './Pickup.module.scss';
import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';
import { ConsumerApiService } from 'services/ConsumerApiService';
import { usePromiseTracker } from 'react-promise-tracker';
import Constants from 'config/constants';
import CircularProgress from '@material-ui/core/CircularProgress';
import ErrorImage from 'assets/svg/error.svg';
import StoreImage from 'assets/svg/store.svg';
import Header from 'components/Header/Header';
import handleAnalyticCall from '../analytics';
import Feedback from 'components/Feedback/Feedback';
import OrderInfo from 'components/OrderInfo/OrderInfo';
import StoreInfo from 'components/StoreInfo/StoreInfo';
import LocationSelection from 'components/LocationSelection/LocationSelection';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import CheckIn from 'components/CheckIn/CheckIn';
import StoreLocations from 'components/StoreLocations/StoreLocations';
import CheckmarkImage from 'assets/svg/checkmark.svg';
import HourglassImage from 'assets/svg/hourglass.svg';
import { Format } from 'utils/Format';
import CheckStatus from 'components/CheckStatus/CheckStatus';
import { useMediaQuery } from 'react-responsive';
import { MetricService } from 'services/MetricService';
import { ThemeProvider, createMuiTheme, } from '@material-ui/core/styles';

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="left" ref={ref} {...props} />;
});

export default function Pickup() {
	const [pickupOrderResponse, setPickupOrderResponse] = useState(null);
	const [notifyResponse, setNotifyResponse] = useState(null);
	const [headerTitle, setHeaderTitle] = useState(null);
	const [headerError, setHeaderError] = useState(false);
	const [headerMessage, setHeaderMessage] = useState(null);
	const [headerImage, setHeaderImage] = useState(StoreImage);
	const [isAnalyzed, setIsAnalyzed] = useState(false);
	const [showCheckIn, setShowCheckIn] = useState(false);
	const [checkInType, setCheckInType] = useState(null);
	const [showMultiStore, setShowMultiStore] = useState(false);
	const [showPickedUp, setShowPickedUp] = useState(false);
	const [selectedStore, setSelectedStore] = useState(null);
	const [checkInResult, setCheckInResult] = useState(null);
	const [expired, setExpired] = useState(false);
	const [otherSelected, setOtherSelected] = useState(false);

	const { promiseInProgress } = usePromiseTracker();

	const Mobile = ({ children }) => {
		const isTablet = useMediaQuery({ maxWidth: 991 })
		return isTablet ? children : null
	}
	const Desktop = ({ children }) => {
		const isDesktop = useMediaQuery({ minWidth: 992 })
		return isDesktop ? children : null
	}

	let query = useQuery();
	let orderNumber = query.get('ordernumber');
	let queryZipcode = query.get('zipcode');
	let pickedUpBy = query.get('pickuptype');
	let zipCode;
	if (queryZipcode) {
		zipCode = queryZipcode.substring(0, 5);
	}
	let extend = query.get('extend');
	let channel = query.get('channel');
	let storeNumber = query.get('storenumber');

	let pickupWebsite = Cookies.get('pickup_website');

	if (!isAnalyzed) {
		setIsAnalyzed(true);
		handleAnalyticCall(pickupWebsite, orderNumber, "", "", "", "", "");
	}

	const circularProgressTheme = createMuiTheme({
		palette: {
			primary: {
				main: pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? "#677406" : (pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? "#002A19" : "#BB5811")
			}
		}
	});

	useEffect(() => {
		if (extend) {
			// &extend=true
			ConsumerApiService.extendPickupOrder(orderNumber, zipCode, channel, storeNumber)
				.then(response => {
					if (response.data.status === Constants.STATUS_EXTENDED && response.data.stores.length > 0) {
						setPickupOrderResponse(response.data.stores);
						setHeaderImage(CheckmarkImage);
						setHeaderTitle(Constants.EXTENDED_TITLE);
						setHeaderMessage(ExtendedHeaderMessage(response.data.extendDate, response.data.stores.find(store => store.orderStatus === Constants.STATUS_READY).name));
						MetricService.setCustomMetric('EXTEND');
					} else if (response.data.stores.filter(store => store.orderStatus === Constants.STATUS_CANCELED).length > 1) {
						setExpired(true);
						let message = pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? Constants.ERROR_EXPIRED_MESSAGE_GG : (pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? Constants.ERROR_EXPIRED_MESSAGE_PL : Constants.ERROR_EXPIRED_MESSAGE_DSG);
						setPickupOrderResponse(response.data.stores);
						setHeaderImage(HourglassImage);
						setHeaderTitle(Constants.EXPIRED_TITLE);
						setHeaderMessage(message);
					} else if (response.data.stores.filter(store => store.orderStatus === Constants.STATUS_PICKED_UP).length > 1) {
						setShowPickedUp(true);
						setPickupOrderResponse(response.data.stores);
						setHeaderImage(CheckmarkImage);
						setHeaderTitle(Constants.PICKED_UP_TITLE);
						setHeaderMessage(`Your order has been picked up. Thank you for shopping at ${pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? "Golf Galaxy" : (pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? "Public Lands" : "DICK'S Sporting Goods")}!`);
					} else {
						handleError();
					}
				}).catch(error => {
				handleError(error);
			});
		} else {
			// &extend=false or null, normal pickup request
			ConsumerApiService.getPickupOrder(orderNumber, zipCode, storeNumber)
				.then(response => {
					if (response.data.stores.find(store => store.queuePosition >= 0)) {
						setSelectedStore(response.data.stores.find(store => store.queuePosition >= 0).location.toString());
						setPickupOrderResponse(response.data.stores);
						setHeaderImage(CheckmarkImage);
						setHeaderTitle(Constants.CHECK_IN_RESULT_SUCCESS_TITLE);
						setCheckInResult(Constants.CHECK_IN_RESULT_SUCCESS);
						setNotifyResponse(response.data.stores.find(store => store.queuePosition >= 0));
						setHeaderMessage(InitialHeaderMessage(response.data.stores.find(store => store.queuePosition >= 0)));
					}	else if (response.data.status === Constants.STATUS_FOUND && response.data.stores.length > 0) {
						if (response.data.stores.find(store => store.orderStatus === Constants.STATUS_READY && response.data.stores.find(store => store.openStatus === Constants.STORE_STATUS_OPEN || store.openStatus === Constants.STORE_STATUS_IN_STORE || store.openStatus === Constants.STORE_STATUS_CURBSIDE))) {
							if (response.data.stores.filter(store => store.orderStatus === Constants.STATUS_READY).length > 1) {
								setShowMultiStore(true);
							}
							setPickupOrderResponse(response.data.stores);
							MetricService.setCustomMetric('CHECKIN');
						} else if (response.data.stores.filter(store => store.orderStatus === Constants.STATUS_PICKED_UP).length >= 1) {
							setShowPickedUp(true);
							setPickupOrderResponse(response.data.stores);
							setHeaderImage(CheckmarkImage);
							setHeaderTitle(Constants.PICKED_UP_TITLE);
							setHeaderMessage(`Your order has been picked up. Thank you for shopping at ${pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? "Golf Galaxy" : (pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? "Public Lands" : "DICK'S Sporting Goods")}!`);
						} else {
							handleError();
						}
					} else {
						handleError();
					}
				}).catch(error => {
				handleError(error);
			});
		}
		// eslint-disable-next-line
	}, [orderNumber, zipCode, extend]);

	const handleCheckStatus = () => {
		ConsumerApiService.getPickupOrder(orderNumber, zipCode, storeNumber)
			.then(response => {
				if (
					response.data.status === Constants.STATUS_FOUND &&
					response.data.stores.length > 0 &&
					response.data.stores.find(store => store.queuePosition >= 0 &&
					response.data.stores.find(store => store.openStatus === Constants.STORE_STATUS_OPEN || store.openStatus === Constants.STORE_STATUS_IN_STORE || store.openStatus === Constants.STORE_STATUS_CURBSIDE))
				) {
					setNotifyResponse(response.data.stores.find(store => store.queuePosition >= 0));
					setHeaderMessage(InitialHeaderMessage(response.data.stores.find(store => store.queuePosition >= 0)));
					handleAnalyticCall(pickupWebsite, orderNumber, `${response.data.stores.find(store => store.queuePosition >= 0)}`, pickedUpBy, "CheckStatus", "", "");
				} else if (response.data.stores.filter(store => store.orderStatus === Constants.STATUS_PICKED_UP).length >= 1) {
					window.location.reload(true);
				}
			}).catch(() => {
		});
	}

	const handleNotifyStore = (storeNumber, details, located, placement, type) => {
		ConsumerApiService.notifyByWebsite(orderNumber, zipCode, storeNumber, details, located, placement, type, pickedUpBy)
			.then(response => {
				if (response.status === 200) {
					if (response.data.status === 'conflict') {
						window.location.reload(true);
					} else {
						setHeaderMessage(InitialHeaderMessage(response.data));
						setNotifyResponse(response.data);
						setCheckInResult(Constants.CHECK_IN_RESULT_SUCCESS);
						setHeaderImage(CheckmarkImage);
						setHeaderTitle(Constants.CHECK_IN_RESULT_SUCCESS_TITLE);
					}
				} else {
					setCheckInResult(Constants.CHECK_IN_RESULT_FAILED);
				}
			}).catch(error => {
			handleError(error);
		});
		window.scroll(0, 0);
		handleAnalyticCall(pickupWebsite, orderNumber, storeNumber.toString(), pickedUpBy, "Notify", "", "");
		MetricService.setNotifyMetric(type, details, located, placement, otherSelected);
	};

	const handleError = (error) => {
		let state = pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? Constants.ERROR_FALLBACK_GG : (pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? Constants.ERROR_FALLBACK_PL : Constants.ERROR_FALLBACK_DSG);
		let message = pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? Constants.ERROR_FALLBACK_MESSAGE_GG : (pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? Constants.ERROR_FALLBACK_MESSAGE_PL : Constants.ERROR_FALLBACK_MESSAGE_DSG);
		setHeaderError(true);
		setHeaderTitle(state);
		setHeaderMessage(message);
		setHeaderImage(ErrorImage);
		handleAnalyticCall(pickupWebsite, orderNumber, `${pickupOrderResponse ? (!selectedStore ? pickupOrderResponse[0] : pickupOrderResponse.find(store => store.location.toString() === selectedStore).location.toString()) : ""}`, pickedUpBy, "", state, error ? error.message : message);
	};

	const handleOpenCheckIn = (type) => {
		setShowCheckIn(true);
		setCheckInType(type);
		handleAnalyticCall(pickupWebsite, orderNumber, `${!selectedStore ? pickupOrderResponse[0] : pickupOrderResponse.find(store => store.location.toString() === selectedStore).location.toString()}`, pickedUpBy, `${Format.capitalizeWords(type)}CheckIn`, "", "");
	};

	const handleCloseCheckIn = () => {
		if (checkInResult !== Constants.CHECK_IN_RESULT_SUCCESS) {
			setCheckInResult(null);
		}
		setShowCheckIn(false);
		setCheckInType(null);
		window.scroll(0, 0);
	};

	const handleConfirmStore = (store) => {
		setSelectedStore(store);
		setShowMultiStore(false);
		window.scroll(0, 0);
	};

	const InitialHeaderMessage = (data) => {
		let date = new Date(data.timeCheckedIn.replace(/\s/, 'T')+'Z');
		return (
			<>
				Thanks for checking in at
				<b> {date.toLocaleString('en-US', {
					hour: 'numeric',
					minute: 'numeric',
					hour12: true
				})}! </b>
				{data.queuePosition >= 2 &&
				<>
					There are <b> {data.queuePosition} athletes waiting </b> in front of you.
				</>
				}
				{data.queuePosition === 1 &&
				<>
					There is <b> {data.queuePosition} athlete waiting </b> in front of you.
				</>
				}
				{data.queuePosition === 0 &&
				<>
					You're <b> up next!</b>
				</>
				}
				&nbsp;A teammate has been notified and will be out with your order soon.
				<br/><br/>
				We have confirmed your identity via email and will <b>NOT</b> ask to check your ID.
				{data.queuePosition === 0 && Format.isEligibleForCallStore(new Date(data.timeCheckedIn.replace(/\s/, 'T')+'Z')) &&
				<>
					<br/><br/>
					You can tap CALL STORE below to speak with a teammate about your pickup if desired.
				</>
				}
			</>
		)
	};

	const ExtendedHeaderMessage = (extendDate, store) => {
                let dateString = extendDate.includes(' ')
                        ? extendDate.replace(/\s/, 'T') + 'Z'
                        : extendDate + 'T00:00:00Z';
		let date = new Date(dateString);
		return (
			<>
				Your pickup date has been extended through&nbsp;
				{date.toLocaleString('en-US', {
					weekday: 'long',
					month: 'long',
					day: 'numeric'
				})}. Our teammates in {Format.capitalizeWords(store)} will have your gear ready for you when you arrive!

				<p className="body-small">If you designated an additional pickup person, please let them know that they have extra time to pickup your order.</p>
			</>
		)
	}

	return (
		<div className="app-container bootstrap-container">
			{!pickupOrderResponse && !headerTitle ?
				<div className={classes.CircularProgress}>
					<ThemeProvider theme={circularProgressTheme}>
						<CircularProgress />
					</ThemeProvider>
				</div>
				:
				<div>
					{extend ?
						<div>
							<Mobile>
								<Header className="item"
												promiseInProgress={promiseInProgress}
												orderNumber={orderNumber}
												zipCode={zipCode}
												headerError={headerError}
												headerTitle={headerTitle}
												headerMessage={headerMessage}
												headerImage={headerImage}
												pickupWebsite={pickupWebsite}
												multiStore={showMultiStore}
												pickedUp={showPickedUp}
												extend={extend} />
								{!headerError &&
								<>
									<OrderInfo className="item"
														 orderItems={
															 !selectedStore ?
																 (showPickedUp ?
																	 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_PICKED_UP).items :
																	 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_READY).items) :
																 pickupOrderResponse.find(store => store.location.toString() === selectedStore).items
														 }
														 pickupWebsite={pickupWebsite}
														 pickedUp={showPickedUp}
														 extend={extend} />
									<StoreInfo className="item"
														 stores={pickupOrderResponse}
														 store={
															 !selectedStore ?
																 (showPickedUp ?
																	 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_PICKED_UP) :
																	 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_READY)) :
																 pickupOrderResponse.find(store => store.location.toString() === selectedStore)
														 }
														 openStatus={
															 !selectedStore ?
																 (showPickedUp ?
																	 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_PICKED_UP).openStatus :
																	 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_READY).openStatus) :
																 pickupOrderResponse.find(store => store.location.toString() === selectedStore).openStatus
														 }
														 pickupWebsite={pickupWebsite}
														 checkedIn={checkInResult === Constants.CHECK_IN_RESULT_SUCCESS}
														 pickedUp={showPickedUp}
														 expired={expired} />
								</>
								}
								<Feedback className="item"
													pickupWebsite={pickupWebsite}/>
							</Mobile>
							<Desktop className="container">
								{!headerError
									?
									<div className="row">
										<div className="col">
											<Header promiseInProgress={promiseInProgress}
															orderNumber={orderNumber}
															zipCode={zipCode}
															headerError={headerError}
															headerTitle={headerTitle}
															headerMessage={headerMessage}
															headerImage={headerImage}
															pickupWebsite={pickupWebsite}
															multiStore={showMultiStore}
															pickedUp={showPickedUp}
															extend={extend} />
											<OrderInfo orderItems={
																	 !selectedStore ?
																		 (showPickedUp ?
																			 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_PICKED_UP).items :
																			 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_READY).items) :
																		 pickupOrderResponse.find(store => store.location.toString() === selectedStore).items
																 }
																 pickupWebsite={pickupWebsite}
																 pickedUp={showPickedUp}
																 extend={extend} />
										</div>
										<div className="col">
											<StoreInfo stores={pickupOrderResponse}
																 store={
																	 !selectedStore ?
																		 (showPickedUp ?
																			 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_PICKED_UP) :
																			 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_READY)) :
																		 pickupOrderResponse.find(store => store.location.toString() === selectedStore)
																 }
																 openStatus={
																	 !selectedStore ?
																		 (showPickedUp ?
																			 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_PICKED_UP).openStatus :
																			 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_READY).openStatus) :
																		 pickupOrderResponse.find(store => store.location.toString() === selectedStore).openStatus
																 }
																 pickupWebsite={pickupWebsite}
																 checkedIn={checkInResult === Constants.CHECK_IN_RESULT_SUCCESS}
																 pickedUp={showPickedUp}
																 expired={expired}
																 extend={extend} />
											<Feedback pickupWebsite={pickupWebsite} />
										</div>
									</div>
									:
									<>
										<Header className="item"
														promiseInProgress={promiseInProgress}
														orderNumber={orderNumber}
														zipCode={zipCode}
														headerError={headerError}
														headerTitle={headerTitle}
														headerMessage={headerMessage}
														headerImage={headerImage}
														pickupWebsite={pickupWebsite}
														multiStore={showMultiStore}
														pickedUp={showPickedUp}
														extend={extend} />
										<Feedback pickupWebsite={pickupWebsite} />
									</>
								}
							</Desktop>
						</div>
						:
						<>
							{!showCheckIn &&
							<>
								<Header className="item"
												promiseInProgress={promiseInProgress}
												orderNumber={orderNumber}
												zipCode={zipCode}
												headerError={headerError}
												headerTitle={headerTitle}
												headerMessage={headerMessage}
												headerImage={headerImage}
												pickupWebsite={pickupWebsite}
												multiStore={showMultiStore}
												pickedUp={showPickedUp}
												extend={extend} />
								{!headerError &&
								<>
									{showMultiStore ?
										<>
											<StoreLocations className="item"
																			stores={pickupOrderResponse}
																			handleConfirm={handleConfirmStore}
																			pickupWebsite={pickupWebsite} />
											<OrderInfo className="item"
																 orderItems={pickupOrderResponse}
																 multiStore={showMultiStore}
																 pickupWebsite={pickupWebsite} />
										</>
										:
										<>
											{!checkInResult && !showPickedUp && !extend &&
											<LocationSelection className="item"
																				 pickupWebsite={pickupWebsite}
																				 handleOpenCheckIn={handleOpenCheckIn} />
											}
											{checkInResult === Constants.CHECK_IN_RESULT_SUCCESS && !showPickedUp &&
											<CheckStatus className="item"
																	 pickupWebsite={pickupWebsite}
																	 handleCheckStatus={handleCheckStatus}
																	 store={
																		 !selectedStore ?
																			 (showPickedUp ?
																				 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_PICKED_UP) :
																				 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_READY)) :
																			 pickupOrderResponse.find(store => store.location.toString() === selectedStore)
																	 }
																	 queuePosition={notifyResponse && notifyResponse.queuePosition}
																	 checkInTime={notifyResponse && notifyResponse.timeCheckedIn} />
											}
											<OrderInfo className="item"
																 orderItems={
																	 !selectedStore ?
																		 (showPickedUp ?
																			 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_PICKED_UP).items :
																			 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_READY).items) :
																		 pickupOrderResponse.find(store => store.location.toString() === selectedStore).items
																 }
																 pickupWebsite={pickupWebsite}
																 pickedUp={showPickedUp}
																 extend={extend} />
											<StoreInfo className="item"
																 stores={pickupOrderResponse}
																 store={
																	 !selectedStore ?
																		 (showPickedUp ?
																			 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_PICKED_UP) :
																			 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_READY)) :
																		 pickupOrderResponse.find(store => store.location.toString() === selectedStore)
																 }
																 openStatus={
																	 !selectedStore ?
																		 (showPickedUp ?
																			 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_PICKED_UP).openStatus :
																			 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_READY).openStatus) :
																		 pickupOrderResponse.find(store => store.location.toString() === selectedStore).openStatus
																 }
																 pickupWebsite={pickupWebsite}
																 checkedIn={checkInResult === Constants.CHECK_IN_RESULT_SUCCESS}
																 pickedUp={showPickedUp}
																 expired={expired} />
										</>
									}
								</>
								}
								<Feedback className="item"
													pickupWebsite={pickupWebsite} />
							</>
							}
							{!headerError &&
							<Dialog className="item" fullScreen open={showCheckIn} onClose={handleCloseCheckIn} TransitionComponent={Transition}>
								<CheckIn checkInType={checkInType}
												 setCheckInType={setCheckInType}
												 handleCloseCheckIn={handleCloseCheckIn}
												 handleCheckStatus={handleCheckStatus}
												 handleNotifyStore={handleNotifyStore}
												 checkInResult={checkInResult}
												 store={!selectedStore ? pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_READY) : pickupOrderResponse.find(store => store.location.toString() === selectedStore)}
												 openStatus={
													 !selectedStore ?
														 (showPickedUp ?
															 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_PICKED_UP).openStatus :
															 pickupOrderResponse.find(store => store.orderStatus === Constants.STATUS_READY).openStatus) :
														 pickupOrderResponse.find(store => store.location.toString() === selectedStore).openStatus
												 }
												 pickupWebsite={pickupWebsite}
												 setCheckInResult={setCheckInResult}
												 stores={pickupOrderResponse}
												 queuePosition={notifyResponse && notifyResponse.queuePosition}
												 checkInTime={notifyResponse && notifyResponse.timeCheckedIn}
												 showCheckIn={showCheckIn}
												 setOtherSelected={setOtherSelected} />
							</Dialog>
							}
						</>
					}
				</div>
			}
		</div>
	);
}

// A custom hook that builds on useLocation to parse the query string
function useQuery() {
	return new URLSearchParams(useLocation().search.toLowerCase());
}
